// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.app-main[data-v-6beed8bc] {\r\n  width: 100%;\r\n  height: calc(100% - 35px);\r\n  position: relative;\r\n  overflow: auto;\r\n  background-color: #efefef;\r\n  box-sizing: border-box;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
